import storage from '@/utils/storage';
import { ShieldWarning } from 'phosphor-react';
import * as React from 'react';

export const NotAuthorizedPage = () => {
  const handleGoBack = () => {
    storage.clearAllTokens();
    window.location.assign(window.location.origin);
  };

  return (
    <div className="flex flex-col items-center justify-center w-screen h-screen bg-[#16191D]">
      <ShieldWarning size={84} className="text-white mb-6" />
      <div className="text-center text-white">
        <h1 className="text-4xl font-extrabold mb-4">You are not authorized</h1>
        <p className="text-lg mb-8">
          You are not authorized to access this page. Please go back to home.
        </p>
        <button
          onClick={handleGoBack}
          className="rounded-md px-8 py-4 bg-indigo-600 text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-700 focus:ring-opacity-50"
        >
          Go back to Home
        </button>
      </div>
    </div>
  );
};
